/*
 * @Author: lzy
 * @Date: 2020-05-19 17:12:18
 * @LastEditors: DQL
 * @LastEditTime: 2021-04-25 15:29:55
 * @Description: file content
 */
import axios from 'axios';
import config from '@/config';

const commontCtx = config.commontCtx;

// 查询机构部门树
export const deptTree = (params) => { return axios.get(`${commontCtx}/dept/tree/async`, { params: params }); };

// 根据用户查询权限部门树
export const permissionDeptTree = (params) => { return axios.get(`${commontCtx}/permissionDept/getByCapacityCode`, { params: params }); };

// 查询所有机构部门树
export const allDeptTree = () => {
  return axios.get(`${commontCtx}/dept/tree`, {});
};

export const savePermission = (permission) => { return axios.post(`${commontCtx}/permissionDept/savePermissionDept`, permission); };

// 获取职位列表
export const getPositionList = () => { return axios.get(`${commontCtx}/position/list`); };

// 获取部门岗位列表
export const getRoleList = (deptCode) => { return axios.get(`${commontCtx}/deptRole/dept/${deptCode}`); };

export const userService = {
  // 分页查询用户信息
  query: (params) => { return axios.get(`${commontCtx}/user/query`, { params: params }); },
  // 查询用户信息
  getUserInfo: (userCode) => { return axios.get(`${commontCtx}/user/get/${userCode}`); },
  /* 查询本机构部门用户信息（用于判断用户是否已经存在于当前机构部门） */
  getDeptUserInfo: (userCode, deptCode) => { return axios.get(`${commontCtx}/user/get/${userCode}/${deptCode}`); },
  // 查询其他机构部门是否存在该用户
  userInOtherDept: (deptCode, userCode) => { return axios.get(`${commontCtx}/user/getAccount/${deptCode}/${userCode}`); },
  // 用户新增
  save: (fd) => { return axios.post(`${commontCtx}/user/save`, fd); },
  // 用户修改
  update: (fd) => { return axios.put(`${commontCtx}/user/update`, fd); },
  // 用户密码重置
  resetPwd: (userCode) => { return axios.put(`${commontCtx}/user/update/${userCode}`); },
  // 用户解锁
  unlock: (userCode) => { return axios.put(`${commontCtx}/user/unlock/${userCode}`); },
  // 删除用户
  delUser: (userCode) => { return axios.delete(`${commontCtx}/user/delete/${userCode}`); }
};

export const capacityService = {
  // 分页查询用户身份信息
  list: (params) => { return axios.get(`${commontCtx}/capacity/list`, { params: params }); },
  // 获取用户身份信息
  getCapacity: (capacityCode) => { return axios.get(`${commontCtx}/capacity/get/${capacityCode}`); },
  // 新增用户身份
  save: (fd) => { return axios.post(`${commontCtx}/capacity/save`, fd); },
  // 修改用户身份
  update: (fd) => { return axios.put(`${commontCtx}/capacity/update`, fd); },
  // 变更为主身份
  changeToMain: (capacityCode) => { return axios.put(`${commontCtx}/capacity/change/${capacityCode}`); }
};

export const roleCapacityService = {
  // 查询未关联岗位列表
  getWglRoleList: (capacityCode, deptCode) => { return axios.get(`${commontCtx}/roleCapacity/choose/${capacityCode}/${deptCode}`); },
  // 查询身份岗位关联列表
  getYglRoleList: (capacityCode) => { return axios.get(`${commontCtx}/roleCapacity/list/${capacityCode}`); },
  // 身份岗位关联
  save: (fd) => { return axios.post(`${commontCtx}/roleCapacity/save`, fd); }
};

// 获取扩展字段--用户
export const attrUser = () => { return axios.get(`${commontCtx}/attr/user`); };

// 获取扩展字段--身份
export const attrCapacity = () => { return axios.get(`${commontCtx}/attr/capacity`); };

// 获取扩展字段--机构
export const attrDept = () => { return axios.get(`${commontCtx}/attr/dept`); };
